export enum BILLING_TARIFF_ALIAS {
  FREE = 'free',
  PREMIUM = 'premium',
}

export enum BILLING_TARIFF_PERIOD {
  MONTHLY = 'monthly',
  ANNUALLY = 'annually',
}
